import { contentLanguages } from 'components/CreateContentTranslation/contentLanguages';

export const setLanguageLabel = (languageCode) => {
  const foundLanguage = contentLanguages.find((contentLanguague) => contentLanguague.code === languageCode);

  return foundLanguage ? `${foundLanguage.code} - ${foundLanguage.language}` : '';
};
